export default function Hero() {
  const handleWhatsApp = () => {
    window.open('https://wa.me/18594205881?text=Hola%2C%20necesito%20información%20sobre%20sus%20servicios', '_blank');
  };

  const handleStartBusiness = () => {
    document.getElementById('contact-section')?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0 z-0">
        <img
          src="https://public.readdy.ai/ai/img_res/3ad0c9d24c1796a4cadddedd91d2495a.jpg"
          alt="PaisaNet Hero Background"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/40 to-black/50"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 w-full max-w-7xl mx-auto px-6 py-20 text-center">
        {/* Logo */}
        <div className="mb-8 flex justify-center">
          <img
            src="https://static.readdy.ai/image/7390baca68aebcb14217ef53907c4fd1/befe6694d70ed20c4ba5133d375d2a98.png"
            alt="PaisaNet Logo"
            className="h-72 w-auto"
          />
        </div>

        {/* Main Headline */}
        <h1 className="text-5xl md:text-6xl lg:text-7xl font-bold text-white mb-6 leading-tight">
          Placas, Empresas y Crédito para la Comunidad Latina
        </h1>

        {/* Subheadline */}
        <p className="text-xl md:text-2xl text-white/95 mb-12 max-w-4xl mx-auto leading-relaxed">
          Ayudamos a la comunidad latina con: Placas y Registro Vehicular, Creación de Empresas, EIN, ITIN Number, Reparación de Crédito y Asesoría Empresarial.
        </p>

        {/* CTA Buttons */}
        <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
          <button
            onClick={handleWhatsApp}
            className="group bg-green-500 hover:bg-green-600 text-white px-8 py-4 rounded-lg text-lg font-semibold transition-all duration-300 flex items-center gap-3 shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer"
          >
            <i className="ri-whatsapp-line text-2xl"></i>
            Enviar mensaje por WhatsApp
          </button>
          <button
            onClick={handleStartBusiness}
            className="bg-white hover:bg-gray-50 text-blue-600 px-8 py-4 rounded-lg text-lg font-semibold transition-all duration-300 shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer"
          >
            Empezar mi empresa hoy
          </button>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 z-10 animate-bounce">
        <i className="ri-arrow-down-line text-white text-3xl"></i>
      </div>
    </section>
  );
}